import { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { FormattedMessage } from 'dibs-react-intl';
import { createFragmentContainer, graphql } from 'react-relay/legacy';
import { Link } from 'dibs-elements/exports/Link';
import { isOnDeliveryPane } from '../reducers/checkoutPaneReducer';
import { toggleShipmentNotesAction } from '../actions/commonActions';
import { trackUserInteractionOnce } from '../helpers/checkoutTracking';
import { connect } from 'react-redux';
import styles from './styles/checkoutShipmentNotes.scss';

// components
import CheckoutAllowCustomQuote from './CheckoutAllowCustomQuote';

class CheckoutShipmentNotes extends Component {
    constructor(props) {
        super(props);
        this.onToggle = this.onToggle.bind(this);
    }
    onToggle(event) {
        const { onToggleShipmentNote, isOnDelivery } = this.props;
        event.preventDefault();
        event.stopPropagation();
        trackUserInteractionOnce();
        onToggleShipmentNote(isOnDelivery);
    }
    render() {
        const {
            buyer,
            deliveryOptions,
            shipmentNotes,
            isCustomQuoteSelected,
            hasCustomQuoteError,
            isOnDelivery,
        } = this.props;

        const hasShipmentNote = !!shipmentNotes;

        return !isOnDelivery && hasShipmentNote ? (
            <p>
                <FormattedMessage
                    id="checkout.CheckoutShipmentNotes.requestExists"
                    defaultMessage={`Special instructions or requests: "{shipmentNotes}"`}
                    values={{ shipmentNotes }}
                />
            </p>
        ) : (
            <CheckoutAllowCustomQuote {...{ buyer, deliveryOptions }}>
                {({ allowCustomQuote }) => {
                    const isMandatory = allowCustomQuote && isCustomQuoteSelected;
                    const labelClasses = classNames({
                        [styles.bold]: isOnDelivery && isCustomQuoteSelected,
                        [styles.error]: hasCustomQuoteError,
                    });
                    const linkClasses = classNames(styles.linkSpace, {
                        [styles.link]:
                            (isOnDelivery && !isCustomQuoteSelected) ||
                            !isOnDelivery ||
                            !isMandatory,
                    });
                    const MaybeLink = !isMandatory ? Link : 'span';
                    return (
                        <div
                            className={styles.shipmentNoteWrapper}
                            data-tn="add-special-instructions-link"
                        >
                            <span className={labelClasses}>
                                {isMandatory ? (
                                    <FormattedMessage
                                        id="checkout.CheckoutShipmentNotes.mandatory"
                                        defaultMessage="Mandatory"
                                    />
                                ) : (
                                    <FormattedMessage
                                        id="checkout.CheckoutShipmentNotes.optional"
                                        defaultMessage="Optional"
                                    />
                                )}
                            </span>
                            {':'}
                            <MaybeLink
                                className={linkClasses}
                                onClick={!isMandatory ? this.onToggle : null}
                                buyerLinkType="standardLink"
                            >
                                <FormattedMessage
                                    id="checkout.CheckoutShipmentNotes.mandatoryAddRequest"
                                    defaultMessage="Add special instructions or requests"
                                />
                            </MaybeLink>
                        </div>
                    );
                }}
            </CheckoutAllowCustomQuote>
        );
    }
}

CheckoutShipmentNotes.propTypes = {
    buyer: PropTypes.object,
    deliveryOptions: PropTypes.array,
    shipmentNotes: PropTypes.string,
    isOnDelivery: PropTypes.bool.isRequired,
    isCustomQuoteSelected: PropTypes.bool.isRequired,
    hasCustomQuoteError: PropTypes.bool.isRequired,
    onToggleShipmentNote: PropTypes.func.isRequired,
};

const ConnectedCheckoutShipmentNotes = connect(
    ({ transaction, pane, delivery }) => ({
        isCustomQuoteSelected: delivery.isCustomQuoteSelected,
        hasCustomQuoteError: delivery.hasCustomQuoteError,
        shipmentNotes: transaction.shipmentNotes,
        isOnDelivery: isOnDeliveryPane(pane),
    }),
    {
        onToggleShipmentNote: toggleShipmentNotesAction,
    }
)(CheckoutShipmentNotes);

export default createFragmentContainer(ConnectedCheckoutShipmentNotes, {
    buyer: graphql`
        fragment CheckoutShipmentNotes_buyer on User {
            ...CheckoutAllowCustomQuote_buyer
        }
    `,
    deliveryOptions: graphql`
        fragment CheckoutShipmentNotes_deliveryOptions on ShipmentQuote @relay(plural: true) {
            ...CheckoutAllowCustomQuote_deliveryOptions
        }
    `,
});
